import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Plus } from 'lucide-react';
import InteractionDialog from '@/components/InteractionDialog';
import { InteractionCard, useInteractionLookups } from '@/components/InteractionCard';
import { useAuth } from '@/context/AuthContext';

const API = `${window.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || ''}/api`;

/** Pestaña "Reuniones" de la ficha del jugador: las entradas ligadas a él (el scout ve solo las suyas). */
const PlayerInteractions = ({ player }) => {
  const { user, isAdmin, isSuperAdmin } = useAuth();
  const admin = isAdmin || isSuperAdmin;
  const { topics, clubs, reload } = useInteractionLookups();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialog, setDialog] = useState({ open: false, entry: null });

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/interactions`, { params: { player_id: player.id, limit: 100 } });
      setRows(res.data.data || []);
    } catch (_) { setRows([]); }
    setLoading(false);
  }, [player.id]);

  useEffect(() => { load(); }, [load]);

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-2">
        <div>
          <CardTitle>Reuniones y notas</CardTitle>
          <CardDescription>
            Charlas y reuniones sobre {player.first_name}.{admin ? ' Ves las de todos los scouts.' : ' Ves solo las tuyas.'}
          </CardDescription>
        </div>
        <Button size="sm" className="bg-brand-600 hover:bg-brand-700" onClick={() => setDialog({ open: true, entry: null })} data-testid="player-new-interaction">
          <Plus className="w-4 h-4 mr-1" /> Nueva entrada
        </Button>
      </CardHeader>
      <CardContent className="space-y-3">
        {loading ? <p className="text-sm text-slate-500">Cargando…</p> : rows.length === 0 ? (
          <p className="text-sm text-slate-500" data-testid="player-interactions-empty">Todavía no hay entradas sobre este jugador.</p>
        ) : rows.map((e) => (
          <InteractionCard key={e.id} entry={e} showScout={admin} canEdit={admin || e.created_by === user?.id}
            onEdit={(entry) => setDialog({ open: true, entry })} onDeleted={() => { load(); reload(); }} />
        ))}
      </CardContent>
      <InteractionDialog
        open={dialog.open} onOpenChange={(o) => setDialog((d) => ({ ...d, open: o }))} entry={dialog.entry}
        prefill={{ player_id: player.id, player_name: `${player.first_name} ${player.last_name}`, club: player.origin_club || '' }}
        topics={topics} clubs={clubs} onSaved={() => { load(); reload(); }}
      />
    </Card>
  );
};

export default PlayerInteractions;
